import { useEffect } from 'react'

/**
 * Sets `document.title` to `"{title} - BaseHit"` while mounted, and resets it to
 * the bare "BaseHit" on unmount (or while `title` is undefined — e.g. an entity
 * page whose name is still loading). Resetting on unmount means navigating from a
 * titled page to one that sets no title never leaves a stale title behind.
 *
 * Pass `undefined`/`null` to hold the default "BaseHit" (used while data loads).
 * The default here is the single source of truth for the app title — index.html's
 * static <title>BaseHit</title> is only the pre-hydration value.
 */
export function usePageTitle(title: string | null | undefined) {
  useEffect(() => {
    document.title = title ? `${title} - BaseHit` : 'BaseHit'
    return () => {
      document.title = 'BaseHit'
    }
  }, [title])
}
